export const ROUTES = {
  HOME: '/',
  CONTACT: '/contact',
  SETTINGS: '/settings',
  NOTIFICATIONS: '/notifications',
  CLUSTERS: '/clusters',
  CLUSTER_CREATE: '/clusters/create',
  CLUSTER_EDIT: '/clusters/:clusterId/edit',
  CLUSTER_DETAILS: '/clusters/:clusterId',
  CLUSTER_INSTALLATIONS_ADD: '/clusters/:clusterId/installations-add',
  CLUSTER_INSTALLATION_DETAILS: '/clusters/:clusterId/installations/:installationId',
  CLUSTER_INSTALLATION_METER_DATA: '/clusters/:clusterId/installations/:installationId/meters/:meterId',
  CLUSTER_DATA: '/clusters/:clusterId/data',
  MAP: '/map',
  DOCUMENTS: '/documents',
} as const;
